import { render, staticRenderFns } from "./ReservePlanTable.vue?vue&type=template&id=a87b6d08&scoped=true&"
import script from "./ReservePlanTable.vue?vue&type=script&lang=ts&"
export * from "./ReservePlanTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReservePlanTable.vue?vue&type=style&index=0&id=a87b6d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87b6d08",
  null
  
)

export default component.exports